<template>
    <v-dialog v-model="model" max-width="500" persistent class="rounded-lg">
        <v-card class="rounded-lg">
            <v-card-title :class="backgroundColor">
                <v-row class="justify-center py-2">
                    <v-icon class="mr-4" :color="iconColor">
                        {{ icon }}
                    </v-icon>
                    {{ title }}
                </v-row>
            </v-card-title>
            <v-card-text class="py-4">
                <div class="d-flex flex-row justify-center">
                    <h4>{{ message }}</h4>
                </div>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn :color="type" plain @click="closeDialog()">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ResponseDialog",
    props: ['model', 'type', 'message'],
    computed: {
        title() {
            if (this.type === 'success') {
                return 'Sucesso!';
            }
            if (this.type === 'error') {
                return 'Erro!';
            }
            return 'Atenção!';
        },
        backgroundColor() {
            if (this.type === 'success') {
                return 'success-title';
            }
            if (this.type === 'error') {
                return 'error-title';
            }
            return 'warning-title';
        },
        icon() {
            if (this.type === 'success') {
                return 'mdi-check-circle-outline';
            }
            if (this.type === 'error') {
                return 'mdi-close-circle-outline';
            }
            return 'mdi-alert-circle-outline';
        },
        iconColor() {
            if (this.type === 'warning') {
                return 'black';
            }
            return 'white';
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close');
            this.$emit('update:model', false);
        },
    },
}
</script>

<style scoped>
.error-title {
    background-color: #f44336;
    color: #FFF;
    width: 100%;
}

.success-title {
    background-color: #4caf50;
    color: #FFF;
    width: 100%;
}

.warning-title {
    background-color: #ff9800;
    color: black;
    width: 100%;
}
</style>
